import { FC, PropsWithChildren } from "react";

import { useMarketplace } from "~features/token-details/hook/useMarketplace";
import { HighlightMarketplaceContext } from "~features/token-details/hook/useMarketplaceState";

import { SeriesToken } from "../../apollo/graphql.generated";

const MarketplaceContextWrapper: FC<
  PropsWithChildren & {
    token?: Omit<SeriesToken, "attributes">;
    onTokenRefresh?: () => void;
  }
> = ({ children, token, onTokenRefresh }) => {
  const marketplaceData = useMarketplace(token, onTokenRefresh);
  return (
    <HighlightMarketplaceContext.Provider value={marketplaceData}>
      {children}
    </HighlightMarketplaceContext.Provider>
  );
};

export default MarketplaceContextWrapper;
